export default "__VITE_ASSET__DHApD2QQ__"